export default {
  LOGIN_USER: "LOGIN_USER",
  LOGOUT_USER: "LOGOUT_USER",
  REGISTER_USER: "REGISTER_USER",
  REGISTER_USER_SUCCESS: "REGISTER_USER_SUCCESS",
  OTP_USER: "OTP_USER",
  OTP_USER_SUCCESS: "OTP_USER_SUCCESS",
  RESEND_OTP_USER: "RESEND_OTP_USER",
  RESEND_OTP_USER_SUCCESS: "RESEND_OTP_USER_SUCCESS",
  LOGIN_USER_SUCCESS: "LOGIN_USER_SUCCESS",
  LOGOUT_USER_SUCCESS: "LOGOUT_USER_SUCCESS",

  USER_VOUCHER: "USER_VOUCHER",
  USER_VOUCHER_SUCCESS: "USER_VOUCHER_SUCCESS",
  SET_AUTH_IS_LOADING: "SET_AUTH_IS_LOADING",

  GET_SYSTEM_GOVERNMENT_REQUEST: "GET_SYSTEM_GOVERNMENT_REQUEST",
  GET_SYSTEM_GOVERNMENT_SUCCESS: "GET_SYSTEM_GOVERNMENT_SUCCESS",
  GET_SYSTEM_GOVERNMENT_FAIL: "GET_SYSTEM_GOVERNMENT_FAIL",

  GET_SYSTEM_REGION_REQUEST: "GET_SYSTEM_REGION_REQUEST",
  GET_SYSTEM_REGION_SUCCESS: "GET_SYSTEM_REGION_SUCCESS",
  GET_SYSTEM_REGION_FAIL: "GET_SYSTEM_REGION_FAIL",

  GET_SYSTEM_GRADES_REQUEST: "GET_SYSTEM_GRADES_REQUEST",
  GET_SYSTEM_GRADES_SUCCESS: "GET_SYSTEM_GRADES_SUCCESS",
  GET_SYSTEM_GRADES_FAIL: "GET_SYSTEM_GRADES_FAIL",

  GET_SYSTEM_MAJORS_REQUEST: "GET_SYSTEM_MAJORS_REQUEST",
  GET_SYSTEM_MAJORS_SUCCESS: "GET_SYSTEM_MAJORS_SUCCESS",
  GET_SYSTEM_MAJORS_FAIL: "GET_SYSTEM_MAJORS_FAIL",

  FORGET_PASSWORD: "FORGET_PASSWORD",
  FORGET_PASSWORD_SUCCESS: "FORGET_PASSWORD_SUCCESS",

  FORGET_PASSWORD_OTP_USER: "FORGET_PASSWORD_OTP_USER",
  FORGET_PASSWORD_OTP_USER_SUCCESS: "FORGET_PASSWORD_OTP_USER_SUCCESS",
  RESET_PASSWORD: "RESET_PASSWORD",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
};
